import { createDate, importAll, transformImages } from "utils";

import GalleryComponent from "components/Media/Gallery";
import QuibblerMain from "../../_hp-quibbler-main";
import QuibblerMakingOf from "../../_hp-quibbler-making-of";
import ReplicaBigTitle from "components/Replicas/ReplicaBigTitle";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaQuote from "components/Replicas/ReplicaQuote";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";
import { ReplicaVersionType } from "types";
import background from "./background.jpg";
import thumbnail from "./thumbnail.png";

let gallery = [];
let galleryArticles = [];

try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/)
  );
  galleryArticles = importAll(
    (require as any).context("./gallery-articles", false, /\.(png|jpe?g|svg)$/)
  );
} catch (e) {
  console.log(e);
}

/* VERSION DATA */
export const VERSION_DATA: ReplicaVersionType = {
  isWIP: false,
  page: undefined,
  dateCreated: createDate({ day: 1, month: 5, year: 2025 }),
  datePublished: createDate({ day: 1, month: 7, year: 2025 }),
  version: "1",
  isSeries: false,
  thumbnail,
  background,
};

/* VERSION PAGE */
const Page = () => {
  return (
    <ReplicaContent>
      <QuibblerMain
        gallery={transformImages(gallery)}
        galleryImageOptions={[
          { index: 0, aspectRatio: 1.5 },
          { index: 3, aspectRatio: 1.5 },
          { index: 7, aspectRatio: 1.5 },
          { index: 10, aspectRatio: 1.5 },
        ]}
        video={"https://youtu.be/gRb2DZ1Wbmw"}
      />

      <ReplicaBigTitle title="Undesirable No.1" />

      <ReplicaQuote source="Harry Potter and the Deathly Hallows">
        "Harry, look at this" He strode over to her as quickly as he could
        through all the clutter. The front of the Quibbler carried his own
        picture, emblazoned with the words "Undesirable Number One" and
        captioned with the reward money. "The Quibbler's going for a new angle,
        then?: Harry asked coldly, his mind working very fast. "Is that what you
        were doing when you went into the garden, Mr. Lovegood? Sending an owl
        to the Ministry?
      </ReplicaQuote>
      <ReplicaSpacer />

      <ReplicaParagraph>
        This issue of The Quibbler marks a significant turning point for the
        magazine, as Xenophilius was blackmailed into submission by the Death
        Eaters and began publishing the same anti-Potter and anti–Muggle-born
        propaganda that had long overtaken The Daily Prophet. At this point, the
        Ministry — essentially under Death Eater control — likely had a heavy
        hand in shaping the content The Quibbler was putting out. With that in
        mind, this issue primarily focuses on the Ministry’s version of why
        Harry is being hunted, while also pushing fabricated narratives about
        Muggle-borns. It blames them for recent accidents and crimes, praises
        the Muggle-Born Registration Commission, and generally serves as a
        mouthpiece for the regime’s twisted justifications.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <GalleryComponent
        images={transformImages(galleryArticles)}
        imagesPerRow={3}
        imageOptions={[{ index: 0, aspectRatio: 2 }]}
        imageMaxHeight="250px"
      />
      <ReplicaSpacer />

      <QuibblerMakingOf />
    </ReplicaContent>
  );
};

export default {
  ...VERSION_DATA,
  page: <Page />,
} as ReplicaVersionType;
